import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { TALLERES_NUEVO_EDITAR, TALLERES_LISTA, TALLERES_ANALISIS_REPORTE } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'
import AnalisisDeReportePage from './analisisDeReporte'

export default function TalleresPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${TALLERES_NUEVO_EDITAR}/:id`} component={NuevoPage} />
        <Route path={`/${TALLERES_NUEVO_EDITAR}`} component={NuevoPage} />
        <Route path={`/${TALLERES_LISTA}`} component={ListaPage} />
        <Route path={`/${TALLERES_ANALISIS_REPORTE}`} component={AnalisisDeReportePage} />
      </Switch>
    </Suspense>
  )
}
